import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const RightRibbonContainer = styled(Box)(() => ({
  position: 'absolute',
  right: 0,
  top: 0,
  '&.pdp': {
    zIndex: '1'
  },
  '&.plp': {
    position: 'relative'
  },
  '&.plpLeo': {
    position: 'relative'
  }
}));

export const RightRibbonWrapper = styled(Box)(({theme}) => ({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  '&.plp': {
    flexDirection: 'row',
    paddingTop: theme.spacing(0.5)
  },
  '&.plpLeo': {
    flexDirection: 'row'
  }
}));

export const RightRibbonIconHolder = styled(Box)(({theme}) => ({
  position: 'relative',
  height: theme.spacing(6),
  width: theme.spacing(6),
  marginTop: theme.spacing(0.5),
  marginRight: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(4.75),
    width: theme.spacing(4.75)
  },
  '&.dynamic-image': {
    marginTop: theme.spacing(0.75),
    '&.pdp': {
      marginTop: theme.spacing(1)
    }
  },
  '&.pdp': {
    height: theme.spacing(6),
    width: theme.spacing(6)
  },
  '&.plp': {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginTop: 0,
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(3.75),
      width: theme.spacing(3.75)
    }
  },
  '&.plpLeo': {
    height: theme.spacing(4),
    width: theme.spacing(5.75),
    marginTop: 0,
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(3.5),
      width: theme.spacing(5)
    }
  }
}));
